import { useContext, useSyncExternalStore, type Context } from 'react';
import { createExternalStore } from './create-external-store';

type ExternalStore<T> = ReturnType<typeof createExternalStore<T>>;

// Аналог createStoreHooks, но для сторов, которые раздаются через Context —
// когда стор создаётся один раз на Provider (useRef), а не как модульный синглтон
export function createContextStoreHooks<T>(context: Context<ExternalStore<T> | null>) {
  const useStore = (): ExternalStore<T> => {
    const store = useContext(context);
    if (!store) {
      throw new Error('Store context is missing a Provider higher in the tree');
    }
    return store;
  };

  const useSelector = <R>(selector: (state: T) => R): R => {
    const store = useStore();
    const getSnapshot = () => selector(store.getSnapshot());
    return useSyncExternalStore(store.subscribe, getSnapshot, getSnapshot);
  };

  const useValue = (): T => {
    const store = useStore();
    return useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);
  };

  return { useSelector, useValue };
}
